/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { InputProps } from '@chakra-ui/input';
import theme from '@chakra-ui/theme';

export const Input = {
  parts: ['field', 'addon'],
  baseStyle: {
    field: {
      color: 'white',
      fontWeight: 'bold',
      caretColor: 'currentColor',
      boxShadow:
        '0px 1px 0px 0px rgba(255, 255, 255, 0.25), 0px 3px 6px 0px rgba(0, 0, 0, 0.2) inset',

      '&&': {
        border: '1px solid',
        borderRadius: 'md',
        borderColor: 'transparent',
        bg: 'blackAlpha.700',
      },

      '&::placeholder': {
        color: 'whiteAlpha.800',
      },

      _hover: {
        '&&': {
          border: '1px solid',
          borderColor: 'transparent',
          bg: 'whiteAlpha.400',
          boxShadow: 'none',
        },
      },

      _focus: {
        '&&': {
          border: '1px solid',
          borderColor: 'gamma.100',
          boxShadow: 'none',
        },
      },

      '&:-webkit-autofill': {
        caretColor: 'currentColor',
        '&:hover, &:focus, &:active': { caretColor: 'currentColor' },
      },
    },
    addon: {
      fontSize: 'sm',
      color: 'blackAlpha.700',
      '&&': {
        lineHeight: 'normal',
        fontWeight: 'bold',
        borderRadius: 'base',
        fontFamily: 'accent',
        textShadow: '0px 1px 0px rgba(255, 255, 255, 0.45)',
        bgGradient: 'linear(to-b, #FFBF36, #EEA200)',
        border: 'none',
        boxShadow:
          '0px 2px 5px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset',
      },
    },
  },
  sizes: {
    lg: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
    md: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
  },
  variants: {
    unstyled: (props: InputProps) => {
      const { addon, field } = theme.components.Input.variants.outline(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        props as any
      );

      return {
        addon,
        field: {
          ...field,
          boxShadow: 'none',
          '&&': {
            color: 'black',
            bg: 'white',
            borderRadius: 'base',
            h: '40px',
            borderColor: 'white',
            pl: '2.5',
          },
          '&:focus, &:active, &:hover': {
            '&&': {
              bg: 'white',
              borderColor: 'white',
              color: 'black',
            },
          },
        },
      };
    },
  },
  defaultProps: {},
};
